import { render, staticRenderFns } from "./yetkigruplistesi.vue?vue&type=template&id=51960c4e&"
import script from "./yetkigruplistesi.vue?vue&type=script&lang=js&"
export * from "./yetkigruplistesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports